import { TiChartSeriesComponent } from "../../components/ti-chart-series.component";
import { ChartStyleSettingsModel } from "../../models/chart-style/chart-style-settings.model";
import { HighChartDataPoints } from "../../models/data-point/highchart-data-points.model";
import { TIChartPointModel } from "../../models/data-point/ti-chart-point.model";
import { ChartType } from "../../models/enum/chart-type.enum";

export class TIDataPointToHighChartDataPointMapper {
    public static map(tiChartSeries: TiChartSeriesComponent): HighChartDataPoints {
        let dataPoints: Array<any> = [];
        let dataPointsZone: Array<any> = [];
        let lastZonePoint: any = null;
        for (const data of tiChartSeries.tiChartPoints) {
            dataPoints.push(TIDataPointToHighChartDataPointMapper.toHighChartDataPoint(tiChartSeries, data));

            const zonePoint = TIDataPointToHighChartDataPointMapper.toHighChartZone(tiChartSeries.chartStyleSettings, data);
            if (lastZonePoint == null || lastZonePoint.className != zonePoint.className) {
                dataPointsZone.push(zonePoint);
                lastZonePoint = zonePoint;
            }
        }

        return new HighChartDataPoints({
            points: dataPoints,
            zones: dataPointsZone
        });
    }

    public static toHighChartDataPoint(tiChartSeries: TiChartSeriesComponent, point: TIChartPointModel): any {
        const chartType = tiChartSeries.chartStyleSettings?.chartType;
        let className = tiChartSeries.chartStyleSettings?.isOneColor ? 'one-color' : (point.isUpBar() ? 'up-color' : 'down-color') ;
        if (chartType == ChartType.Line || chartType == ChartType.Area) {
            let close = point.close;
            if (tiChartSeries.chartStyleSettings?.isComparisonSymbolPercentageMode) {
                close = tiChartSeries.highChartComparisonBuilder.getPercentage(point);
            }
            return { x: point.xValue, y: close };
        } else if (chartType == ChartType.Bar) {
            return { x: point.xValue, y: point.open, close: 0, className: className };
        } else if (chartType == ChartType.OHLC || chartType == ChartType.HLC) {
            if (point.goLevel != null && point.goLevel >= 0) {
                className = 'go-level-' + point.goLevel;
            }
        }

        return { x: point.xValue, y: point.open, open: point.open, high: point.high, low: point.low, close: point.close, className: className };
    }

    public static toHighChartZone(chartStyleSettings: ChartStyleSettingsModel | null, point: TIChartPointModel): any {
        return {
            value: point.xValue,
            className: chartStyleSettings?.isOneColor ? 'one-color' : (point.isUpBar() ? 'zone-up-color' : 'zone-down-color')
        };
    }
}